export default "__VITE_PUBLIC_ASSET__f4204929__"